import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { SecurityService } from '../services/security.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    @Inject('$rootScope') private $rootScope,
    private securityService: SecurityService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).catch((err) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        this.$rootScope.$emit('application:out', { err });
      }

      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/interceptors/authentication.interceptor.ts